export default class ProcessStep {
  id = null;
  name = "";
  description = "";
  answers = [];

  userAddsAnswer = null;
  documentationRequired = null;
  processToStart = null;
  startProcessOnFailure = null;

  userMessage = "";
  mailMessage = "";
  contactRoles = [];
  contactOperator = null;

  constructor() {
  }
}
